import { CirclePlus } from 'lucide-react';
import type { ReactNode } from 'react';
import type { TRuleEditorCommonProps } from '../types';
import type { TQuestionRuleAction } from 'types/rules.types';
import { HubertButton } from 'components/HubertUI/HubertButton';

interface Props extends TRuleEditorCommonProps {
  actions: TQuestionRuleAction[];
  renderAction: (action: TQuestionRuleAction, actionIdx: number) => ReactNode;
  addLabel: string;
  onAdd: () => void;
}

const RuleActions = ({ isReadOnly, actions, renderAction, addLabel, onAdd }: Props) => (
  <div className="mt-12 flex flex-col gap-16">
    {actions.map((action, actionIdx) => renderAction(action, actionIdx))}

    {!isReadOnly ? (
      <HubertButton size="sm" variant="outline" icon={<CirclePlus />} onClick={onAdd}>
        {addLabel}
      </HubertButton>
    ) : null}
  </div>
);

export default RuleActions;
